var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseForm',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Заполните первичные данные")]},proxy:true},{key:"buttons",fn:function(){return [_c('Button',{attrs:{"white":""}},[_vm._v("Вернуться")]),_c('Button',{staticStyle:{"float":"right"},attrs:{"disabled":_vm.isDisabled,"loading":_vm.isLoading},on:{"click":_vm.next}},[_vm._v(" Отправить ")])]},proxy:true}])},[_c('v-form',{ref:"form"},[_c('v-row',_vm._l(([
                        'fio',
                        'birthdate',
                        'gender',
                        'birthplace',
                        'income',
                        'passport',
                        'issueDate',
                        'divisionCode',
                        // 'issuePlace',
                        'issuedBy',
                        'registrationAddress',
                        'residentialAddress',
                        'isAddressesMatches',
                        'email',
                        'personalDataProcessing' ]),function(name){return _c('Field',{key:name,attrs:{"anketaName":name}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }